import styles from './Input.module.css';

function Input({
  label,
  error,
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  required = false,
  ...props
}) {
  return (
    <>
      <input
        htmlFor={label}
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`${styles.input} ${error ? styles.error : ''}`}
        {...props}
      />
      {error && <span
        className={styles.errorText}
        aria-invalid="true"
        aria-describedby={error}
      >
        {error}
      </span>}
    </>
  );
}

export default Input;